import React from "react";
import "./HomeSections.css";
import InteractiveImg from "../../assets/Image/NewImages/InteractiveCarrier.jpeg";

function InteractiveCareer() {
  const handleCall = () => {
    window.location.href = "tel:+919886003080";
  };
  return (
    <section className="section-wrapper">
      <div className="container row valign-wrapper flex-wrap">
        <div className="col l6 s12 center">
          <img
            src={InteractiveImg}
            alt=""
            className="responsive-img custom-img"
          />
        </div>

        <div className="col l6 s12">
          <h4>Interactive Career & Stream Activities</h4>
          <p>
            Evaluate your motivators, work style, and more with interactive
            activities.
          </p>
          <p>
            Zero-in on your perfect career or stream based on your personal
            preferences.
          </p>
          <p>Ensure a great career that fits your lifestyle and goals.</p>

          <button className="custom-btn" onClick={handleCall}>
            Schedule A Call Back
          </button>
        </div>
      </div>
    </section>
  );
}

export default InteractiveCareer;
